import React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { IconButton, Paper, useTheme } from '@mui/material'
import Close from '@mui/icons-material/Close'

const BigModal = ({ open, onClose, autoWidth, style, children, ...props }) => {
  const defaultStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // On phones a shrink-to-fit modal collapses to a ~200px sliver and an
    // 80% one leaves little room — use (almost) the full width below `sm`.
    // Callers' `style` still overrides.
    width: { xs: 'calc(100vw - 24px)', sm: autoWidth ? 'auto' : '80%' },
    maxWidth: { xs: 'calc(100vw - 24px)', sm: '90vw' },
    ...(!props.hideBackgroundColor && { bgcolor: props.bgcolor ?? '#FFF' }),
    borderRadius: 1,
    boxShadow: props.hideBackgroundColor ? 0 : 24,
    borderColor: 'none',
    padding: 1,
    overflow: 'auto',
    outline: 'none',
    maxHeight: '85vh',
  }
  return (
    <Modal
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
          onClick: (event) => {
            event.stopPropagation()
          },
        },
      }}
    >
      <Box
        sx={{ ...defaultStyle, ...style }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </Box>
    </Modal>
  )
}

export default BigModal
